import { useTranslation } from 'react-i18next';
import { siteConfig } from '../siteConfig';
import { Divider } from '../components/Divider';
import './Contact.css';

export function Contact() {
  const { t } = useTranslation();
  return (
    <section id={siteConfig.sections.contact.anchor} className="section contact">
      <Divider />
      <div className="section-header">
        <div className="section-kicker">{t('contact.title')}</div>
      </div>
      <p className="contact__ask">{t('contact.ask')}</p>
      <div className="contact__emails">
        <a href="mailto:hello@jnforever.fyi" className="contact__email">
          hello@jnforever.fyi
        </a>
      </div>
    </section>
  );
}
